const getDefaultState = () => {
    return {
        properties: {},
        singleProperty: {},
        addProperty: {}
    }
}


const state = getDefaultState()

const getters = {
    getProperties: state => state.properties,
    getSingleProperty: state => {
        let property = state.singleProperty;
        return (property == null || property == undefined || !property) ? {} : property;
    },
    getAddProperty: state => state.addProperty
};

const mutations = {
    resetPropertiesState: (state) => Object.assign(state, getDefaultState()),
    setProperties: (state, properties) => state.properties = properties,
    setSingleProperty: (state, singleProperty) => state.singleProperty = singleProperty,
    setAddProperty: (state, addProperty) => state.addProperty = addProperty,
    resetAddProperty: (state) => state.addProperty = {}
};

const actions = {
    async fetchProperties({commit, getters}){
        const propertyData = await axios({
            method: 'GET',
            url: window.config.apiUrl + 'api/property/list',
            cancelToken: window.AuthorizationCancelSource.token,
        })
        commit('setProperties', propertyData.data);
    },
    fetchSingleProperty({commit, getters}, propertyId){
        if(propertyId == null){
            commit('setSingleProperty', {})
        }
        else{
            axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/property/' + propertyId,
                cancelToken: window.AuthorizationCancelSource.token,
            }).then(response => {
                commit('setSingleProperty', response.data);
            })
        }
    },
    removeProperties({commit}){
        commit('setProperties', {});
        commit('setSingleProperty', null)
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
